import React, { useState } from 'react'
import SlotDetail from '../components/SlotDetail'
import banner from '../Assets/lottery_banner.png'
import RecentWins from '../components/RecentWins'
import LatestResults from '../components/LatestResults'
import bannerpc from '../Assets/bannerpc.webp'
import LotteryGames from '../components/LotteryGames'
const Wallet = () => {

  const slots = [
    {
      prize:50000,
      displayAmt:'50,000',
      eta:'02:56:06',
      maxParticpants:50,
      joined:54,
      amount:15
    },{
      prize:50000,
      displayAmt:'50,000',
      eta:'02:56:06',
      maxParticpants:50,
      joined:54,
      amount:15
    },{
      prize:50000,
      displayAmt:'50,000',
      eta:'02:56:06',
      maxParticpants:50,
      joined:54,
      amount:15
    },{
      prize:50000,
      displayAmt:'50,000',
      eta:'02:56:06',
      maxParticpants:50,
      joined:54,
      amount:15
    },{
      prize:50000,
      displayAmt:'50,000',
      eta:'02:56:06',
      maxParticpants:50,
      joined:34,
      amount:15
    },{
      prize:50000,
      displayAmt:'50,000',
      eta:'02:56:06',
      maxParticpants:50,
      joined:34,
      amount:15
    },{
      prize:50000,
      displayAmt:'50,000',
      eta:'02:56:06',
      maxParticpants:50,
      joined:34,
      amount:15
    },{
      prize:50000,
      displayAmt:'50,000',
      eta:'02:56:06',
      maxParticpants:50,
      joined:34,
      amount:15
    }
    
  ]
  const [activeSlot,setActiveSlot] = useState({

  })
  const [showDetail,setShowDetail] = useState(false)

  const colors = [
    "green",
    "#66cc66", // Lighter green
    "blue",
    "purple",
    "red",
  ];
  return (
    <div className='p-4'>
      <div className='lottery_banner flex rounded-lg justify-between p-6 px-10 shadow-md shadow-green-600'>
        <div className='flex flex-col space-y-4'>
        <p className='font-bold text-5xl text-white'>
          Lottery
        </p>
        <p className='font-bold text-2xl text-gray-400'>
          Play our lottery games and hit the jackpot
        </p>
        </div>
          
        {/* <img src={bannerpc} alt='banner'/> */}
      </div>
      <LotteryGames/>
      <div className='p-5'>
        {
          //recent wins
        }
        <RecentWins/>
      </div>
      <div className=''>
      <p className='font-bold text-white p-2'>Latest Results</p>
        <LatestResults/>
      </div>
    </div>
  )
}

export default Wallet